// extracted by mini-css-extract-plugin
module.exports = {"page":"_code__page__SKag9","heroWrapper":"_code__heroWrapper__1SMft","heroContent":"_code__heroContent__RjiEp","legal":"_code__legal__KH6Sf"};